import * as PIXI from 'pixi.js';
import game from "@/model/game";

export class DebugOverlay extends PIXI.Container {
    static DEFAULT_FONT_SIZE = 18;
    static DEFAULT_FONT_COLOR = 0x00FF00;

    constructor(style) {
        super();

        const defaultStyle = new PIXI.TextStyle({
            fontSize: DebugOverlay.DEFAULT_FONT_SIZE,
            fill: DebugOverlay.DEFAULT_FONT_COLOR,
        });

        this._textField = new PIXI.Text("", { ...defaultStyle, ...style });

        this._ticker = new PIXI.Ticker();
        this._ticker.add(() => {
            this.update();
        });
        this._ticker.start();

        this.addChild(this._textField);
    }

    update() {
        const text = `bpm: ${game.bpm}\n` + 
                     `mode: ${game.mode}\n` + 
                     `practice: ${game.practiceMode}\n` + 
                     `tempo override: ${game.practiceModeTempoPercent}%\n` + 
                     `stop mode: ${game.practiceModeStops}\n` + 
                     `godmode: ${game.settings?.godMode}\n`;
        if (this._textField.text != text) {
            this._textField.text = text;
        }
    }
}